import React from 'react'
import { FormattedMessage } from 'react-intl'

export const NEXT = (
    <FormattedMessage
        id='migration_screen.navigation.next'
        defaultMessage='Далее'
    />
)

export const TO_STRONGHOLD = (
    <FormattedMessage
        id='migration_screen.navigation.to_stronghold'
        defaultMessage='К Укрепрайону'
    />
)



// WEBPACK FOOTER //
// ./containers/MigrationScreen/components/Slider/translations.jsx